import type { ContactFormValues } from '../types/formSubmissions';
import type { HiddenContactFields } from '../types/templateForms';

// ID types that require front + back uploads (driver's licenses)
export const DRIVER_LICENSE_TYPES = ["Canadian driver's license", "Foreign driver's license"];

// ID types that require a single upload
export const SINGLE_UPLOAD_ID_TYPES = [
    'Canadian passport',
    'Foreign passport',
    'Birth certificate',
    'Permanent Resident card',
];

// Matches the visual order of optional fields in ContactInfoSection.
export const OPTIONAL_CONTACT_FIELD_OPTIONS: (keyof HiddenContactFields)[] = [
    'firstId',
    'secondId',
    'middleName',
    'homePhone',
    'homeAddress',
    'homeUnit',
    'dateOfBirth',
    'maritalStatus',
    'citizenshipStatus',
    'gender',
    'preferredPronouns',
    'occupation',
    'employer',
    'employerAddress',
    'employerUnit',
    'employerPhone',
];

/** English display labels for non-file contact fields, in display order. */
export const CONTACT_FIELD_DISPLAY_LABELS = {
    firstIdType: 'First ID Type',
    secondIdType: 'Second ID Type',
    firstName: 'First Name',
    middleName: 'Middle Name',
    lastName: 'Last Name',
    email: 'Email',
    cellPhone: 'Cell Phone',
    homePhone: 'Home Phone',
    homeAddress: 'Home Address',
    homeUnit: 'Home Unit',
    dateOfBirth: 'Date of Birth',
    gender: 'Gender',
    preferredPronouns: 'Preferred Pronouns',
    maritalStatus: 'Marital Status',
    citizenshipStatus: 'Citizenship Status',
    occupation: 'Occupation',
    employer: 'Employer',
    employerAddress: 'Employer Address',
    employerUnit: 'Employer Unit',
    employerPhone: 'Employer Phone',
} as const satisfies Partial<Record<keyof ContactFormValues, string>>;

export type ContactDisplayFieldKey = keyof typeof CONTACT_FIELD_DISPLAY_LABELS;

export const CONTACT_DISPLAY_FIELD_ORDER = Object.keys(
    CONTACT_FIELD_DISPLAY_LABELS,
) as ContactDisplayFieldKey[];

/** ID upload fields on a contact, in display order, with their file mapping titles. */
export const CONTACT_ID_UPLOAD_FIELDS = [
    { field: 'firstIdFront', title: 'First ID - Front' },
    { field: 'firstIdBack', title: 'First ID - Back' },
    { field: 'firstIdSingle', title: 'First ID' },
    { field: 'secondIdFront', title: 'Second ID - Front' },
    { field: 'secondIdBack', title: 'Second ID - Back' },
    { field: 'secondIdSingle', title: 'Second ID' },
] as const satisfies ReadonlyArray<{ field: keyof ContactFormValues; title: string }>;
